import { getFullName, getInitials } from "@msuite/utils/users";
import { useAuthContext } from "../../auth";
import { Avatar } from "../../avatar";
import { Menu } from "../../menu";
import { Tag } from "../../tag";
import type { NavigationProps } from "../types";

/** Props Interface */
interface TopbarNavigationMenuProps extends Pick<NavigationProps, "menuItems"> {}

export function TopbarNavigationMenu({ menuItems }: TopbarNavigationMenuProps) {
	/** Hooks */
	const { user } = useAuthContext();

	/** Render */
	return (
		<div className="h-stack">
			<Menu items={menuItems}>
				<div className="card h-stack gap-3 p-0.5 rounded-full pl-5">
					<Tag
						variant="plain"
						color="emerald"
						withPing
						className="text-xs"
					>
						{getFullName(user)}
					</Tag>
					<div
						data-cy="navigation-avatar"
						className="flex"
					>
						<Avatar
							size="lg"
							imageUrl={user?.image}
							variant="image"
							initials={user?.initials || getInitials(user)}
						/>
					</div>
				</div>
			</Menu>
		</div>
	);
}
